import { createTheme } from "@mui/material/styles";

const theme = createTheme({
	typography: {
		fontFamily: ["Poppins", "Roboto", "sans-serif"].join(","),
	},
});

export default theme;
